import { render, staticRenderFns } from "./ElBackTop.vue?vue&type=template&id=bdb96b1e&scoped=true&"
import script from "./ElBackTop.vue?vue&type=script&lang=ts&"
export * from "./ElBackTop.vue?vue&type=script&lang=ts&"
import style0 from "./ElBackTop.vue?vue&type=style&index=0&id=bdb96b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb96b1e",
  null
  
)

export default component.exports